/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { useSelect } from '@wordpress/data';
import {
	InnerBlocks,
	store as blockEditorStore,
} from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */
import Inspector from './inspector';

const Edit = ( props ) => {
	const { className, isSelected, clientId, attributes } = props;
	const { blockClientId } = attributes;

	const { hasInnerBlocks } = useSelect(
		( select ) => {
			const { getBlock } = select( blockEditorStore );
			const block = getBlock( clientId );
			return {
				hasInnerBlocks: !! ( block && block.innerBlocks.length ),
			};
		},
		[ clientId ]
	);

	const wrapperClasses = classnames(
		className,
		`gutenify-block-container-wrapper`,
		`gutenify-section-${ blockClientId }`,
	);
	return <div className={ wrapperClasses }>
		{ isSelected && <Inspector { ...props } /> }
		<div className="gutenify-container">
			<InnerBlocks
				renderAppender={ hasInnerBlocks ? false : () => (
					<InnerBlocks.ButtonBlockAppender />
				) }
			/>
		</div>
	</div>;
};

export default Edit;
